import { IkeFieldType } from '@ikegps/core-api';
import type { FormModelField } from '../../form/form.field';
import { CollectionModelField, ModelMutator } from '../collection.field';
import { registerFieldType } from './field.registry';

export class ModelMutatorYesNo extends ModelMutator<FormModelField, CollectionModelFieldYesNo> {
	manual(newValue: boolean) {
		this.state.setFieldValue(this.field.id, newValue);
	}
}

export class CollectionModelFieldYesNo extends CollectionModelField<FormModelField, boolean> {
	static readonly TYPE: IkeFieldType = IkeFieldType.YES_NO;
	static isYesNoField(f: CollectionModelField): f is CollectionModelFieldYesNo {
		return f.schema.type === CollectionModelFieldYesNo.TYPE;
	}

	private _Mutator: ModelMutatorYesNo;
	get Mutator() {
		if (this._Mutator == null) {
			this._Mutator = new ModelMutatorYesNo(this);
		}
		return this._Mutator;
	}

	override get value() {
		return Boolean(this.stateValue);
	}

	hasValue(): boolean {
		return true;
	}
}

registerFieldType(IkeFieldType.YES_NO, (parent, schema) => new CollectionModelFieldYesNo(parent, schema));
